import { atom } from 'recoil'
import { Image } from '../types/Image'

export const MarkedImage = atom<Image | undefined>({
  key: 'marked-image-interaction',
  default: undefined,
})
